exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".billing-product-message-alert{background-color:#096;color:#fff;text-align:center;padding:.25rem 1rem;border-radius:4rem;font-size:.8rem;margin-top:.5rem;margin-bottom:1rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-478917e2","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/WeightProducts.vue
// module id = 3HMu
// module chunks = 0